import Vue from 'vue'

import {
  SWITCH,
  SWITCH_VALUE
} from './types'

export default {
  [SWITCH] (state, payload) {
    // Use Vue.set instead of Object.assign to add a reactive property
    Object.keys(payload).forEach((k) => {
      if (!state.hasOwnProperty(k)) {
        Vue.set(state, k, {})
      }
      Vue.set(state[k], 'enabled', payload[k])
    })
  },
  [SWITCH_VALUE] (state, payload) {
    // Use Vue.set instead of Object.assign to add a reactive property
    Object.keys(payload).forEach((k) => {
      if (!state.hasOwnProperty(k)) {
        Vue.set(state, k, {})
      }
      Vue.set(state[k], 'value', payload[k])
    })
  }
}
